import merge from 'lodash/merge';
import DomainResource from './DomainResource';
import CodeableConcept from './types/CodeableConcept';
import Quantity from './types/Quantity';
import Reference from './types/Reference';

export default class BN_MedPassDose extends DomainResource {
    static __className = 'BN_MedPassDose';

    __objectStructure = {
        patient: Reference,
        request: Reference,
        slot: String,
        dayKey: String,
        doseStatus: String, // open | closed | withdrawn
        windowMinutes: Number,
        dose: Quantity,
        instruction: String,
        route: CodeableConcept,
        sequence: Number,
        episode: Reference,
        location: Reference,
        program: Reference,
        owner: Reference,
        administration: Reference,
        preparedOn: String,
        preparedBy: Reference,
        generatedOn: String,
    };

    constructor(constructJson, className = 'BN_MedPassDose') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
